import classNames from 'classnames'
import { h } from 'preact'
import { useCallback, useMemo, useState } from 'preact/hooks'
import { KeywordSubmitError } from 'src/common/hooks/useStepsManager'
import { InlineNotice, InlineNoticeType } from 'src/common/types'

export const KeywordInput = (props: {
  onSubmit: (val: string) => boolean // true: step unlocked
  isWrong?: boolean
  keywordSubmitError?: KeywordSubmitError
  resetSubmitError?: () => void
  userDefinedInlineNotice?: InlineNotice
}) => {
  const { onSubmit: onSubmitProp, resetSubmitError } = props

  const [keywordInput, setKeywordInput] = useState('')
  const [submitCount, setSubmitCount] = useState<number>(0)

  const onChange: h.JSX.GenericEventHandler<HTMLInputElement> = useCallback(
    (e) => {
      resetSubmitError?.()
      setKeywordInput((e.target as HTMLInputElement).value)
    },
    [resetSubmitError]
  )

  const onSubmit = useCallback(() => {
    setSubmitCount((i) => i + 1)
    const unlocked = onSubmitProp(keywordInput)

    if (unlocked) {
      setKeywordInput('')
    }
  }, [keywordInput, onSubmitProp])

  const noticeText = useMemo(() => {
    if (props.userDefinedInlineNotice !== undefined) {
      return props.userDefinedInlineNotice.message
    }
    return props.keywordSubmitError === 'NO_MATCH'
      ? 'キーワードが間違っています'
      : props.keywordSubmitError === 'ALREADY_USED'
      ? 'すでに使用されたキーワードです'
      : undefined
  }, [props.keywordSubmitError, props.userDefinedInlineNotice])

  const noticeType = useMemo((): InlineNoticeType | undefined => {
    if (props.userDefinedInlineNotice !== undefined) {
      return props.userDefinedInlineNotice.noticeType
    }
    if (props.keywordSubmitError !== undefined) {
      return 'ERROR'
    }
    return undefined
  }, [props.keywordSubmitError, props.userDefinedInlineNotice])

  return (
    <div className="keyword_form">
      <p>パスワードを入力</p>
      <div className="form_area">
        <input type="text" onInput={onChange} value={keywordInput} />
        <button onClick={onSubmit} disabled={keywordInput === ''}>
          送信
        </button>
      </div>
      {noticeText && (
        <p
          key={submitCount}
          className={classNames('inlineNotice', {
            wrongNotice: noticeType === 'ERROR',
          })}
        >
          {noticeText}
        </p>
      )}
    </div>
  )
}
